import { render, staticRenderFns } from "./epb-recursive-facet-values.component.vue?vue&type=template&id=41235120&scoped=true"
import script from "./epb-recursive-facet-values.component.vue?vue&type=script&lang=ts"
export * from "./epb-recursive-facet-values.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-recursive-facet-values.component.vue?vue&type=style&index=0&id=41235120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41235120",
  null
  
)

export default component.exports